import { updateThemeSelected } from '@slice/select.slice';
import { RootState } from 'app/store';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { light, dark, blue, green, yellow, brown, pink } from 'styles/Theme.styled';

const ThemeContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 5px;
`;

const ThemeButton = styled.button`
  margin: 0 2px;
  padding: 2px;
  font-size: 0.5rem;
  border-radius: 5px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  border: 1px solid ${({ theme }: any) => theme.colors!.border};
  &:hover {
    box-shadow: 0px 0px 0px 1px ${({ theme }: any) => theme.colors!.border};
  }
`;

export default function ThemSelect(props: any) {
  const dispatch = useDispatch();
  const HandleThemeChange = theme => {
    dispatch(updateThemeSelected(theme));
  };
  const selectedTheme = useSelector((state: RootState) => state.select.themeSelected);

  return (
    <ThemeContainer theme={selectedTheme}>
      <ThemeButton
        theme={selectedTheme}
        className={`light ${selectedTheme === light ? 'active-theme' : ''}`}
        onClick={() => HandleThemeChange(light)}
      ></ThemeButton>
      <ThemeButton
        theme={selectedTheme}
        className={`dark ${selectedTheme === dark ? 'active-theme' : ''}`}
        onClick={() => HandleThemeChange(dark)}
      ></ThemeButton>
      <ThemeButton
        theme={selectedTheme}
        className={`blue ${selectedTheme === blue ? 'active-theme' : ''}`}
        onClick={() => HandleThemeChange(blue)}
      ></ThemeButton>
      <ThemeButton
        theme={selectedTheme}
        className={`green ${selectedTheme === green ? 'active-theme' : ''}`}
        onClick={() => HandleThemeChange(green)}
      ></ThemeButton>
      <ThemeButton
        theme={selectedTheme}
        className={`yellow ${selectedTheme === yellow ? 'active-theme' : ''}`}
        onClick={() => HandleThemeChange(yellow)}
      ></ThemeButton>
      {/* <ThemeButton
        theme={selectedTheme}
        className={`brown ${selectedTheme === brown ? 'active-theme' : ''}`}
        onClick={() => HandleThemeChange(brown)}
      ></ThemeButton>
      <ThemeButton
        theme={selectedTheme}
        className={`pink ${selectedTheme === pink ? 'active-theme' : ''}`}
        onClick={() => HandleThemeChange(pink)}
      ></ThemeButton> */}
    </ThemeContainer>
  );
}
